import script from "./DocsAndCommunication.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsAndCommunication.vue?vue&type=script&setup=true&lang=js"

import "./DocsAndCommunication.vue?vue&type=style&index=0&id=6dcf3a61&lang=css"

const __exports__ = script;

export default __exports__